import { render, staticRenderFns } from "./points_magnification_setting.vue?vue&type=template&id=154cebcb&scoped=true&"
import script from "./points_magnification_setting.vue?vue&type=script&lang=ts&"
export * from "./points_magnification_setting.vue?vue&type=script&lang=ts&"
import style0 from "./points_magnification_setting.vue?vue&type=style&index=0&id=154cebcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154cebcb",
  null
  
)

export default component.exports